import Nullstack from 'nullstack';
export default function IconColumnsOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-columns-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M4 6h2"
  }), "   ", Nullstack.element("path", {
    d: "M4 10h5.5"
  }), "   ", Nullstack.element("path", {
    d: "M4 14h5.5"
  }), "   ", Nullstack.element("path", {
    d: "M4 18h5.5"
  }), "   ", Nullstack.element("path", {
    d: "M14.5 6h5.5"
  }), "   ", Nullstack.element("path", {
    d: "M14.5 10h5.5"
  }), "   ", Nullstack.element("path", {
    d: "M18 14h2"
  }), "   ", Nullstack.element("path", {
    d: "M14.5 18h3.5"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}